<footer class="nrc-footer">
  <div class="nrc-footer__inner">
    <a class="nrc-footer__logo" routerLink="/">
      <img src="assets/images/logo-alt.svg" alt="Nest Builder" />
    </a>
    <ul class="nrc-footer__links">
      <li><span>&copy; 2025 All rights reserved</span></li>
      @for (link of links; track link.name) {
        <li><a routerLink="/{{ link.route }}">{{ link.name }}</a></li>
      }
    </ul>
  </div>
</footer>
